module.exports = {
  background: {
    url: null,
    stroke: 'none',
    fill: 'FF0000'
  },
  bkgd_color: '#FFFFFF',
  bkgd_url: '',
  img_save: 'embed',
  save_notice_done: false,
  export_notice_done: false
};
